import request from './request';

function getTodo(data) {
	const { todoID, ...others } = data;
	return request({
		url: `/todoes/${todoID}`,
		method: 'GET',
		params: others,
	});
}

function updateTodoChecked(data) {
	const { todoID, ...others } = data;
	return request({
		url: `/todoes/${todoID}/checked`,
		method: 'PUT',
		data: others,
	});
}

function createTodo(data) {
	return request({
		url: `/todoes`,
		method: 'POST',
		data: data,
	});
}

function updateTodo(data) {
	const { todoID, ...others } = data;
	return request({
		url: `/todoes/${todoID}`,
		method: 'PUT',
		data: others,
	});
}

function deleteTodo(data) {
	const { todoID, ...others } = data;
	return request({
		url: `/todoes/${todoID}`,
		method: 'DELETE',
		data: others,
	});
}

export default {
	getTodo,
	updateTodoChecked,
	createTodo,
	updateTodo,
	deleteTodo,
};
